import apiService from '../apiService';

const uploadDocumentService = {

  async uploadDocument(payload, token) {
    try {
      const response = await apiService.post(`/file-uploads/${token}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async verifyDocUploadToken(token) {
    try {
      const response = await apiService.get(`/file-uploads/verify/${token}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

};

export default uploadDocumentService;